import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppPermission } from '../shared/constants';

export function permissionGuard(requiredPermission: AppPermission | AppPermission[]): CanActivateFn {
    return (route, state) => {
        const authService = inject(AuthService);
        const router = inject(Router);

        const permissions = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];

        if (authService.hasPermission(AppPermission.SYSTEM_MANAGE) || permissions.some(p => authService.hasPermission(p))) {
            return true;
        } else {
            return router.parseUrl('/access-denied');
        }
    };
}
